<template>
  <div>
    <facit-header></facit-header>
      <div class = "profile-div col-12">
        <h5 class="mt-3 mb-3"> Downloads </h5>
        <br><br>
        <b-table  striped hover
                  :fields="fields"
                  :items="downloads">
          <template slot="link" slot-scope="data">
            <a :href='data.value' target="_blank"><v-icon name="download" base-class="icon-width"></v-icon></a>
          </template>
        </b-table><br><br><br>
        <div style="font-size:8px;color:#d6d6d6;">
        This software uses code of <a style="color:#d6d6d6 !important;" href="http://ffmpeg.org">FFmpeg</a> licensed under the <a style="color:#d6d6d6 !important;" href=http://www.gnu.org/licenses/old-licenses/lgpl-2.1.html>LGPLv2.1</a> and its source can be downloaded <a style="color:#d6d6d6 !important;" href=http://idcloak.s3.amazonaws.com/downloads/Source/ffmpeg-0.8.tar.gz>here</a> and build instructions <a style="color:#d6d6d6 !important;" href=https://trac.ffmpeg.org/wiki/CompilationGuide/MinGW>here</a><br>
        This software uses code of <a style="color:#d6d6d6 !important;" href="https://libav.org">Libav</a> licensed under the <a style="color:#d6d6d6 !important;" href=https://www.gnu.org/licenses/old-licenses/lgpl-2.1.html>LGPLv2.1</a> and its source can be downloaded <a style="color:#d6d6d6 !important;" href=http://idcloak.s3.amazonaws.com/downloads/Source/libav-11.1.zip>here</a> and build instructions <a style="color:#d6d6d6 !important;" href=https://libav.org/documentation/platform.html>here</a>
        </div>
      </div>
  </div>
</template>

<script>
import FacitHeader from '@/components/header';
import API from '@/api';
import Session from '@/Session';

export default {
  name: 'Downloads',
  components: { FacitHeader },
  data() {
    const token = Session.getAccessToken();
    const userRole = token.user.role;
    return {
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      role: userRole,
      downloads: [],
      fields: [
        {
          key: 'name',
          label: 'Name',
          sortable: true,
        },
        {
          key: 'version',
          label: 'Version',
          sortable: true,
        },
        {
          key: 'link',
          label: 'Downloads',
          sortable: false,
        },
      ],
    };
  },
  created() {
    this.getDownloads();
  },
  methods: {
    async getDownloads() {
      const downloads = await API.get('Downloads');
      downloads.forEach(records => {
        if (this.role === 'admin' && records.type === 7) {
            this.downloads.push(records);
        } else if (records.type != 7) {
          this.downloads.push(records);
        }
      })

      this.totalRows = this.downloads.length;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icon-width {
  width: 20px !important;
  height: 20px !important;
}
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
  width: 95% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/downloads.vue